import AuthForm from './AuthForm/AuthForm';
export default AuthForm;